/* 人员及资产管理相关 */
import {
  SET_ASSET_LIST_FOR_USER,
  SET_ASSET_LIST,
  SET_GUIDE
} from '../mutation-types'
import manageService from 'service/manage.js'
const state = {
  assetAll: [], // 已配置的 和 可配置给 某个用户的资产列表 "资产配置" 弹窗使用
  assetLeftOver: 0, // 可分配的资产总数
  assetListReady: 0,
  isGuide: false, // 展示引导
  searchBy: 'getAssetList' // searchAssetList 或 getAssetList
}

const mutations = {
  // 将某个用户对应的资产 存入store中
  [SET_ASSET_LIST] (state, {list}) {
    state.assetAll = list
  },
  // 1. 将某个用户对应的资产 存入store中
  [SET_ASSET_LIST_FOR_USER] (state, {list}) {
    let assetLeftOver = 0
    state.assetAll = list
    list.forEach((item) => {
      if (!item.gldUserId) {
        assetLeftOver++
      }
    })
    state.assetLeftOver = assetLeftOver
    state.assetListReady++
  },
  // 2. 设置引导
  [SET_GUIDE] (state, isGuide) {
    state.isGuide = isGuide
  }
}

const actions = {
  // 获取当前行用户 可配置和已配置资产列表
  searchAssetList ({state, commit}, item) {
    state.searchBy = 'searchAssetList'
    const {gldUserId, products = []} = item
    return new Promise((resolve, reject) => {
      manageService.getAssetList({gldUserId}, {products}).then((res) => {
        if (+res.code === 200 && res.data) {
          commit('SET_ASSET_LIST', {list: res.data})
        } else {
          commit('SET_ASSET_LIST', {list: []})
        }
        setTimeout(() => {
          resolve()
        }, 100)
      }).catch((e) => {
        reject(e)
        commit('SET_ASSET_LIST', {list: []})
      })
    })
  },
  // 1. 获取当前行用户 可配置和已配置资产列表
  getAssetList ({state, commit}, item) {
    const {gldUserId, products = []} = item
    state.assetListReady = 0
    // state.assetAll = []
    state.assetLeftOver = 0
    state.searchBy = 'getAssetList'
    return new Promise((resolve, reject) => {
      manageService.getAssetList({gldUserId}, {products}).then((res) => {
        if (+res.code === 200 && res.data) {
          commit('SET_ASSET_LIST_FOR_USER', {list: res.data})
        } else {
          commit('SET_ASSET_LIST_FOR_USER', {list: []})
        }
        setTimeout(() => {
          resolve()
        }, 100)
      }).catch((e) => {
        console.log(e)
        reject(e)
        commit('SET_ASSET_LIST_FOR_USER', {list: []})
      })
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
